import { render, staticRenderFns } from "../../DataTableV2ItemViewMobile/DataTableV2ItemViewMobile.html?vue&type=template&id=4eb599d6&external"
import script from "./PriceItemTableViewMobile.js?vue&type=script&lang=js&external"
export * from "./PriceItemTableViewMobile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VToolbar})
